import React from "react";
import { Link } from "gatsby";
import { slide as Menu } from "react-burger-menu";

class BurgerMenu extends React.Component {
    showSettings(event) {
        event.preventDefault();
    }

    render() {
        return (
            <Menu {...this.props} className="block lg:hidden px-2">
                {this.props.links.map(item => (
                    <Link
                        key={item.link_url}
                        to={item.link_url}
                        className="rounded transition-all ease-in-out duration-300 inline-block px-3 py-2 bg-felt-600 mb-2 text-white hover:bg-felt-700"
                        activeClassName="font-bold"
                    >
                        {item.link_title}
                    </Link>
                ))}
            </Menu>
        );
    }
}

export default BurgerMenu;